export const currency = '€';
export const currentYear = new Date().getFullYear();
export const buyLink = '';
export const developedByLink = '';
export const supportLink = 'mailto:stackbros07@gmail.com';